<template>
  <b-modal
    v-model="activModel"
    v-if="activModel"
    centered
    :title="`${type != 'ADD' ? 'تعديل حملة تبرع' : 'إضافة حملة تبرع'}`"
    id="modal-camping"
    footer-class="removed"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    static
  >
    <validation-observer ref="capmpingValidation">
      <b-form class="auth-login-form mt-2" @submit.prevent>
        <div class="model_events">
          <form-image-input
            label="صورة الحملة"
            id="form-image"
            name="image"
            v-model="infoModal.imageSubmit"
            @change="previewImage"
          />
          <!-- <b-form-group label="صورة الحملة">
            <validation-provider
              #default="{ errors }"
              name="صورة الحملة"
              :rules="type == 'ADD' ? 'required' : ''"
              id="campaign-file"
              mode="passive"
            >
              <b-form-file
                accept="image/*"
                placeholder="اختر صورة"
                @change="previewImage"
                v-model="infoModal.imageSubmit"
                browse-text="تصفح"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <div class="border rounded-lg text-center mb-1">
            <img
              v-if="infoModal.image"
              :src="infoModal.image"
              class="img-fluid rounded-lg"
              id="preview"
            />
            <feather-icon v-else icon="ImageIcon" class="my-3" size="30" />
          </div> -->

          <form-input
            label="اسم حملة التبرع"
            v-model="infoModal.name"
            rules="required"
          />
          <form-select
            label="نوع الحملة"
            :options="optionsType"
            :reduce="(el) => el.value"
            :getOptionLabel="(x) => x.title"
            v-model="selectTypeInvide"
            rules="required"
          />
          <form-select
            multiple
            rules="required"
            label="الفئات المستهدفة"
            id="ageCategory"
            v-model="infoModal.selectedCategories"
            :reduce="(x) => x.id"
            :getOptionLabel="(x) => x.name_ar"
            ep="/v2/selects/age-categories"
            :closeOnSelect="false"
          />

          <form-mask
            v-if="selectTypeInvide == 0"
            label="العدد"
            id="number"
            v-model="infoModal.number"
            :raw="false"
            placeholder="10,000"
            options="number"
            rules="required"
          />
          <form-mask
            v-if="selectTypeInvide == 1"
            label="مبلغ التبرع"
            id="number"
            v-model="infoModal.campaign_amount"
            :raw="false"
            placeholder="10,000"
            options="number"
            rules="required"
          />

          <form-mask
            options="date"
            placeholder="YYYY-MM-DD"
            label="تاريخ بداية الحملة"
            id="start-date"
            v-model="infoModal.start_date"
            rules="required"
          />
          <form-mask
            options="date"
            placeholder="YYYY-MM-DD"
            label="تاريخ نهاية الحملة"
            id="end-date"
            v-model="infoModal.end_date"
            rules="required"
          />

          <form-select
            label="المحافظة"
            v-model="infoModal.governorate"
            :getOptionLabel="(x) => x.name_ar"
            :reduce="(x) => x.id"
            id="sgovernorate_manage_camaping"
            ep="v2/selects/governorates"
            rules="required"
          />
          <b-form-group label="تفاصيل" label-for="details">
            <validation-provider
              #default="{ errors }"
              name="حقل التفاصيل"
              rules="required"
              id="details"
              mode="passive"
            >
              <quill-editor
                :options="editorOption"
                v-model="infoModal.description"
                :class="{ quillEditor: errors.length > 0 }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mx-1"
            @click="activModel = false"
          >
            إلغاء <feather-icon icon="Trash2Icon" />
          </b-button>
          <b-button
            v-if="type == 'ADD'"
            type="submit"
            variant="primary"
            @click="formSubmitCreate"
          >
            إضافة <feather-icon icon="EditIcon" />
          </b-button>

          <b-button
            v-else
            variant="primary"
            type="submit"
            @click="formSubmitEdit"
          >
            تعديل <feather-icon icon="EditIcon" />
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BRow,
  BButton,
  BFormFile,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BFormTimepicker,
  BImg,
  BForm,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import FormSelect from "@/components/form-select/index.vue";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import FormMask from "@/components/form-mask";
import FormTextarea from "@/components/form-textarea/index.vue";
import FormInput from "@/components/form-input/index.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import FormDatepicker from "@/components/form-datepicker/index.vue";
import FormImageInput from "@/components/FormImageInput.vue";

import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import { mapGetters } from "vuex";

export default {
  props: {
    value: Boolean,
    info: Object,
    type: String,
    currentPage: Number,
  },
  components: {
    BModal,
    BRow,
    BButton,
    BFormFile,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BFormTimepicker,
    FormSelect,
    BImg,
    ValidationProvider,
    ValidationObserver,
    togglePasswordVisibility,
    BForm,
    FormMask,
    FormTextarea,
    FormInput,
    FeatherIcon,
    FormDatepicker,
    quillEditor,
    FormImageInput,
  },
  data: () => ({
    validateImage: false,
    start_time: "",
    end_time: "",
    optionsType: [
      { value: 1, title: "مادية" },
      { value: 0, title: "عيني" },
    ],
    editorOption: {
      modules: {
        toolbar: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ['link'],
        ]
      }
    },
    selectTypeInvide: null,
    infoModal: {
      name: "",
      number: null,
      campaign_amount: null,
      governorate: null,
      start_date: "",
      end_date: "",
      description: "",
      image: null,
      imageSubmit: null,
      selectedCategories: [],
    },
  }),

  methods: {
    formSubmitCreate() {
      if (this.infoModal.image == null) {
        this.validateImage = true;
      }
      this.$refs.capmpingValidation.validate().then(async (success) => {
        if (success) {
          this.addCamping();
          this.unFilter();
        }
      });
    },
    formSubmitEdit() {
      this.$refs.capmpingValidation.validate().then(async (success) => {
        if (success) {
          this.editCamping();
          this.activModel = false;
        }
      });
    },
    unFilter() {
      this.infoModal.name = "";
      this.infoModal.number = null;
      this.selectTypeInvide = null;
      this.infoModal.campaign_amount = 0;
      this.infoModal.governorate = null;
      this.infoModal.start_date = "";
      this.infoModal.end_date = "";
      this.infoModal.description = "";
      this.infoModal.image = null;
      this.infoModal.imageSubmit = null;
      this.infoModal.selectedCategories = [];
    },
    initState() {
      this.infoModal.number = this.info.count;
      this.infoModal.governorate = this.info.governorate.id;
      this.infoModal.start_date = this.info.start_date;
      this.infoModal.end_date = this.info.end_date;
      this.infoModal.name = this.info.name_ar;
      this.infoModal.description = this.info.description_ar;
      this.infoModal.campaign_amount = this.info.campaign_amount || "";
      if (this.info.campaign_type) {
        this.selectTypeInvide = this.info.campaign_type;
      } else {
        this.selectTypeInvide = this.info.campaign_type;
      }
      this.infoModal.selectedCategories = this.info.ageCategories.map(
        (el) => el.id
      );
    },
    editCamping() {
      const fd = new FormData();
      if (this.infoModal.imageSubmit) {
        fd.append("image", this.infoModal.imageSubmit);
      }
      fd.append("name_ar", this.infoModal.name);
      fd.append("description_ar", this.infoModal.description);
      if (this.infoModal.campaign_amount) {
        fd.append(
          "campaign_amount",
          this.infoModal.campaign_amount.replace(/\D/g, "")
        );
      }

      fd.append("_method", "PUT");
      fd.append("governorate_id", this.infoModal.governorate);
      fd.append("campaign_type", this.selectTypeInvide);
      fd.append("start_date", this.infoModal.start_date);
      fd.append("end_date", this.infoModal.end_date);
      if (this.selectTypeInvide == 0) {
        fd.append("count", this.infoModal.number);
      }

      for (var i = 0; i < this.infoModal.selectedCategories.length; i++) {
        fd.append("age_category_id[]", this.infoModal.selectedCategories[i]);
      }
      this.$store.dispatch("manageInterfaceNgo/ngoCampaign/editCampaign", {
        id: this.info.id,
        page: this.currentPage,
        fd: fd,
      });
    },
    addCamping() {
      const fd = new FormData();
      if (this.infoModal.imageSubmit) {
        fd.append("image", this.infoModal.imageSubmit);
      }
      fd.append("name_ar", this.infoModal.name);
      // fd.append("_method", "PUT");
      fd.append("description_ar", this.infoModal.description);
      fd.append(
        "campaign_amount",
        this.infoModal.campaign_amount.replace(/\D/g, "")
      );
      fd.append("governorate_id", this.infoModal.governorate);
      fd.append("campaign_type", this.selectTypeInvide);
      fd.append("start_date", this.infoModal.start_date);
      fd.append("end_date", this.infoModal.end_date);
      if (this.selectTypeInvide == 0) {
        fd.append("count", this.infoModal.number);
      }
      for (var i = 0; i < this.infoModal.selectedCategories.length; i++) {
        fd.append("age_category_id[]", this.infoModal.selectedCategories[i]);
      }
      // fd.append("age_category_id[]", this.infoModal.selectedCategories);
      this.$store.dispatch("manageInterfaceNgo/ngoCampaign/createCampaign", {
        // id: this.info.id,
        page: this.currentPage,
        fd: fd,
      });
      this.activModel = false;
    },

    previewImage(event) {
      var input = event.target.files[0];
      this.infoModal.image = URL.createObjectURL(input);
    },
  },

  computed: {
    ...mapGetters("manageInterfaceNgo/ngoCampaign", ["confirmed"]),
    activModel: {
      set(val) {
        this.unFilter();
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  created() {
    if (this.type != "ADD") {
      this.initState();
    }
  },
};
</script>
<style lang="scss">
.model_events {
  .dropdown-menu.show {
    width: 235px;
  }
}
[dir="rtl"] .b-form-timepicker .dropdown-menu {
  right: 0%;
}
</style>
